import type { TourStep } from '../types';
import { finishStep } from './common';

export const layoutJobsSteps: TourStep[] = [
  {
    target: 'body',
    placement: 'center',
    title: 'Генератор макетов',
    content: 'Здесь живут все серии: от черновика до макетов в каталоге. Покажем, как найти нужное задание и понять, что с ним делать дальше.',
  },
  {
    target: '[data-tour="lg-jobs-create"]',
    title: 'Новая серия',
    content: '«Создать задание» открывает мастер: выбор способа, тема и аудитория, стиль серии, запуск. Черновик сохраняется сам — можно начать и вернуться позже.',
  },
  {
    target: '[data-tour="lg-jobs-bulk"]',
    title: 'Много тем сразу',
    content: '«Создать пачку заданий» делает бесплатные черновики по списку тем и по подтверждению готовит для них идеи. Дальше каждая серия ждёт вашего выбора направления.',
  },
  {
    target: '[role="tablist"][aria-label="Виды заданий"]',
    title: 'Вкладки — ваш список дел',
    content: 'Начинайте день с «Ждут меня»: там серии, которые остановились и ждут решения. «С ошибкой» — что упало, «Готово к отправке» — что можно отправить в каталог.',
  },
  {
    target: 'input[aria-label="Поиск по названию задания"]',
    title: 'Поиск по названию',
    content: 'Ищет по названию задания среди всех заданий, а не только загруженных строк.',
  },
  {
    target: '[aria-controls="layout-jobs-filters"]',
    title: 'Все фильтры',
    content: 'Этап, тип макета, способ создания, «Ждёт моего решения», характеристика, номер тематики и даты. Фильтры и поиск сохраняются в адресе — ссылкой можно поделиться.',
  },
  {
    target: '[role="group"][aria-label="Вид списка: таблица или доска"]',
    title: 'Таблица или доска',
    content: 'Таблица — подробно и с действиями. Доска раскладывает задания по колонкам этапов: видно, где копится работа.',
  },
  {
    target: '[data-tour="lg-jobs-row"]',
    title: 'Открыть задание',
    content: 'Незавершённая серия откроется сразу в студии, где принимаются решения. Серия после утверждения или с ошибкой производства — на странице задания (паспорте серии).',
  },
  {
    target: '[data-testid="studio-stage-line"]',
    title: 'Текущий шаг',
    content: 'Статус, этап студии и что с ним: «ждёт решения», «генерируется» или «ошибка». Ссылка под ним — следующее действие.',
  },
  {
    target: '[data-testid="job-mini-progress"]',
    title: 'Прогресс серии',
    content: 'Три части полосы: собрано, передано в каталог, принято. Ниже — сколько листов ждут приёмки и бейдж «Возврат», если приёмка что-то вернула.',
  },
  {
    target: 'button[aria-label^="Просмотр листов:"]',
    title: 'Быстрый просмотр',
    content: 'Глаз показывает собранные и утверждённые листы без перехода в задание.',
  },
  {
    target: 'button[aria-label^="Дублировать задание"]',
    title: 'Копия настроек',
    content: 'Новое задание с теми же настройками — удобно повторить удачную серию на другую тему или исправить тему после запуска.',
  },
  {
    target: 'button[aria-label^="Удалить задание"]',
    title: 'Удаление',
    content: 'Убирает задание из списка и останавливает генерацию. Недоступно, если в серии есть утверждённые или отправленные макеты.',
  },
  finishStep,
];
